import * as React from "react";
import {observer} from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { DetailRowList, DetailRowListItem } from "../text/DetailRow";

interface Props extends WithTranslation {
  tax_in_prices: boolean;
  fees: OrderServiceFee[];
  taxes: OrderTaxes[];
  discount: number;
  promo: RestaurantPromo | null;
  totalCart: number;
  total: number;
  tip: number;
}

interface Injected extends Props {}

interface State {}

@observer
class OrderTotalsClass extends React.Component<Props, State> {

  render() {
    const { t, tax_in_prices, fees, taxes, discount, promo, total, totalCart, tip } = this.props as Injected;

    const details: DetailRowListItem[] = [
      {
        l: <span className="small">{t("order.totals.cart")}</span>,
        v: <span className="small">{t("currency", { value: totalCart })}</span>,
      },
    ];

    if (tip > 0) {
      details.push({
        l: <span className="small">{t("order.totals.tip")}</span>,
        v: <span className="small">{t("currency", { value: tip })}</span>,
      });
    }

    if (discount > 0 && promo) {
      details.push({
        l: (
          <span className="small">
            {(!!promo.fixed_discount && !!promo.percent_discount) && t("order.totals.promo", { name: promo.code, value: promo.fixed_discount, percent: promo.percent_discount })}
            {(!!promo.fixed_discount && !promo.percent_discount) && t("order.totals.promo_fixed", { name: promo.code })}
            {(!promo.fixed_discount && !!promo.percent_discount) && t("order.totals.promo_percent", { name: promo.code, percent: promo.percent_discount })}
          </span>
        ),
        v: <span className="small">-{t("currency", { value: discount })}</span>,
      });
    }

    for (const { name, value, fixed_value, percent_value, voided } of fees) {
      details.push({
        l: (() => {
          if (voided) {
            return (
              <s>
                <span className="small">
                  {(fixed_value === 0 && percent_value === 0) && name}
                  {((fixed_value > 0) && (percent_value > 0)) && t("order.totals.fee", { name: name, value: fixed_value, percent: percent_value })}
                  {((percent_value > 0) && !fixed_value) && t("order.totals.fee_percent", { name: name, percent: percent_value })}
                  {((fixed_value > 0) && !percent_value) && t("order.totals.fee_fixed", { name: name })}
                </span>
              </s>
            );
          }
          return (
            <span className="small">
              {(fixed_value === 0 && percent_value === 0) && name}
              {((fixed_value > 0) && (percent_value > 0)) && t("order.totals.fee", { name: name, value: fixed_value, percent: percent_value })}
              {((percent_value > 0) && !fixed_value) && t("order.totals.fee_percent", { name: name, percent: percent_value })}
              {((fixed_value > 0) && !percent_value) && t("order.totals.fee_fixed", { name: name })}
            </span>
          );
        })(),
        v: (() => {
          const d = value === 0 ? "FREE" : t("currency", { value });
          if (voided) {
            return <s><span className="small">{d}</span></s>;
          }
          return <span className="small">{d}</span>;
        })(),
      });
    }

    for (const { name, rate, amount } of taxes) {
      details.push({
        l: (
          <span className="small">
            {!tax_in_prices && t("order.totals.tax", { name: name, percent: rate })}
            {tax_in_prices && t("order.totals.tax_in_prices", { name: name, percent: rate })}
          </span>
        ),
        v: <span className="small">{t("currency", { value: amount })}</span>,
      });
    }

    details.push({
      l: <span className="font-bold">{t("order.totals.total")}</span>,
      v: <span className="font-bold">{t("currency", { value: total })}</span>,
    });

    return (
      <div style={{marginTop: "8px"}}>
        <DetailRowList
          spacing={8}
          items={details}
        />
      </div>
    );
  }

}

export const OrderTotals = withTranslation()(OrderTotalsClass);
